export default {
    toolbar: {
        toolbar: 'Inicio'
    }
}